import { IDefaultReturn } from '~/utils/masks';

export const BIOMETRICS_ORIGIN = [
  {
    id: 'TODAS',
    name: 'Todas',
    value: 'Todas',
  },
  {
    id: 'T_SENHA',
    name: 'Alteração de senha',
    value: 'Alteração de senha',
  },
  {
    id: 'T_EMPRESTIMO',
    name: 'Empréstimo Hotmoney',
    value: 'Empréstimo Hotmoney',
  },
  {
    id: 'T_CHANGE_PERSONAL_DATA',
    name: 'Alteração de dados',
    value: 'Alteração de dados',
  },
  { id: 'T_DEVICE_ID', name: 'Device ID', value: 'Device ID' },
  { id: 'PROPOSTA', name: 'Proposta', value: 'Proposta' },
  {
    id: 'T_ADD_CARD_WALLET',
    name: 'Adicionar cartão na carteira',
    value: 'Adicionar cartão na carteira',
  },
];

export const BIOMETRICS_ORIGIN_BANKNOW = [
  {
    id: 'TODAS',
    name: 'Todas',
    value: 'Todas',
  },
  {
    id: 'T_SENHA',
    name: 'Alteração de senha',
    value: 'Alteração de senha',
  },
  {
    id: 'T_SENHA_CHANGE_PROFILE',
    name: 'Alteração de senha no perfil',
    value: 'Alteração de senha no perfil',
  },
  {
    id: 'T_EMPRESTIMO',
    name: 'Empréstimo Hotmoney',
    value: 'Empréstimo Hotmoney',
  },
  {
    id: 'T_CHANGE_PERSONAL_DATA',
    name: 'Alteração de dados',
    value: 'Alteração de dados',
  },
  { id: 'T_DEVICE_ID', name: 'Device ID', value: 'Device ID' },
  { id: 'PROPOSTA', name: 'Proposta', value: 'Proposta' },
  {
    id: 'T_ADD_CARD_WALLET',
    name: 'Adicionar cartão na carteira',
    value: 'Adicionar cartão na carteira',
  },
  {
    id: 'T_REPRINT_CARD',
    name: 'Reimpressão de cartão',
    value: 'Reimpressão de cartão',
  },
  {
    id: 'T_INSTALLMENT_TEUCARD',
    name: 'Limite parcelado 12x',
    value: 'Limite parcelado 12x',
  }
]

export const RESULTS_BANKNOW = [
  {
    id: 'TODOS',
    name: 'Todos',
    value: 'Todos',
  },
  {
    id: "APPROVED",
    name: "Aprovado",
    value: "Aprovado",
  },
  {
    id: "REJECTED",
    name: "Reprovado",
    value: "Reprovado",
  },
  {
    id: "FAIL",
    name: "Falha",
    value: "Falha"
  }
]

export const RESULT_LIVENESS = [
  {
    id: 'TODOS',
    name: 'Todos',
    value: 'Todos',
  },
  {
    id: '1.0',
    name: '1.0 - Vida aprovada',
    value: '1.0 - Vida aprovada',
  },
  {
    id: '300.1',
    name: '300.1 - Vida reprovada retentativa',
    value: '300.1 - Vida reprovada retentativa',
  },
  {
    id: '300.2',
    name: '300.2 - Vida reprovada bloqueado',
    value: '300.2 - Vida reprovada bloqueado',
  },
];

export const BASE_RESULT_FACES = [
  {
    id: 'TODOS',
    name: 'Todos',
    value: 'Todos',
  },
  {
    id: '201',
    name: '201 - Cadastro com sucesso',
    value: '201 - Cadastro com sucesso',
  },
  {
    id: '203',
    name: '203 - Certificacao positiva',
    value: '203 - Certificacao positiva',
  },
  {
    id: '204',
    name: '204 - Certificacao negativa',
    value: '204 - Certificacao negativa',
  },
  {
    id: '401',
    name: '401 - Falha na qualidade',
    value: '401 - Falha na qualidade',
  },
  {
    id: '501',
    name: '501 - Falha interna',
    value: '501 - Falha interna',
  },
];

export const BIOMETRIA_TYPE_OPTIONS = [
  { id: 'banknow', name: 'BankNow', value: 'BankNow' },
  { id: 'unico', name: 'Unico', value: 'Unico' },
  { id: 'blocked', name: 'Clientes bloqueados', value: 'Clientes bloqueados' },
];

export const RESULTADO_AUTENTICACAO_UNICO = [
  { id: 'TODOS', name: 'Todos', value: 'Todos' },
  { id: 'AUTHENTICATION_RESULT_POSITIVE', name: 'Positivo', value: 'Positivo' },
  { id: 'AUTHENTICATION_RESULT_NEGATIVE', name: 'Negativo', value: 'Negativo' },
  { id: 'AUTHENTICATION_RESULT_INCONCLUSIVE', name: 'Inconclusivo', value: 'Inconclusivo' },
  { id: 'AUTHENTICATION_RESULT_UNSPECIFIED', name: 'Não especificado', value: 'Não especificado' },
];

export const RESULTADO_ALERTA_COMPORTAMENTO_UNICO = [
  { id: 'TODOS', name: 'Todos', value: 'Todos' },
  { id: 'TRUST_RESULT_YES', name: 'Sim', value: 'Sim' },
  { id: 'TRUST_RESULT_INCONCLUSIVE', name: 'Inconclusivo', value: 'Inconclusivo' },
  { id: 'TRUST_RESULT_UNSPECIFIED', name: 'Não especificado', value: 'Não especificado' },
];

export const BiometriaUnicoDisplay = {
  AUTHENTICATION_RESULT_POSITIVE: 'Positivo',
  AUTHENTICATION_RESULT_NEGATIVE: 'Negativo',
  AUTHENTICATION_RESULT_INCONCLUSIVE: 'Inconclusivo',
  AUTHENTICATION_RESULT_UNSPECIFIED: 'Não especificado',
  TRUST_RESULT_YES: 'Sim',
  TRUST_RESULT_INCONCLUSIVE: 'Inconclusivo',
  TRUST_RESULT_UNSPECIFIED: 'Não especificado',
};

export interface FormState {
  cpf: IDefaultReturn;
  origem: string;
  resultLiveness: string;
  baseResultFace: string;
  dataBiometriaInicial: string;
  dataBiometriaFinal: string;
  biometriaType?: 'unico' | 'banknow' | 'blocked';
  codigoAutenticacao?: string;
  codigoComportamento?: string;
  status?: string;
  nome?: string;
}
